import { create } from 'zustand';

export const useModuleCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openModuleCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null};
  }),
}));
export const openModuleCreate = (payload) => {
  const store = useModuleCreateStore.getState();
  store.openModuleCreate(payload);
};

export const closeModuleCreate = () => {
  const store = useModuleCreateStore.getState();
  store.close();
};